import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { JsonConvert } from 'json2typescript';
import { User } from '../models/user';
import { RedirectResponse } from '../models/redirect-response';
import { WindowService } from '../services/window.service';
import { AppConfig } from '../app-config/app.config';
import { AnalyticService } from '../services/analytic.service';

import * as moment from 'moment';
import { Moment } from 'moment';
import { StoreAnalyticsService } from '../services/store.analytics.service';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.css']
})
export class TermsComponent implements AfterViewInit, OnInit {

  constructor(private windowService: WindowService,
              private router: Router,
              private route: ActivatedRoute,
              private userService: UserService,
              private appConfig: AppConfig,
              private analyticService: AnalyticService,
              private storeAnalyticsService: StoreAnalyticsService
  ) {
  }

  user: User;
  termError: boolean;
  processing: boolean;
  startedReadingAt: Moment;
  campaignId: string;

  ngOnInit(): void {
    this.campaignId = this.getCampaignIdQueryParam();
  }

  ngAfterViewInit() {
    this.storeAnalyticsService.trackPageViewed('User Reg Terms and Conditions', 'Sign Up');
    this.analyticService.termsAndConditionsPageView();

    this.windowService.scrollTo(0, 0);
    this.startedReadingAt = moment();
  }

  getCampaignIdQueryParam() {
    if (this.route && this.route.snapshot && this.route.snapshot.queryParams) {
      return this.route.snapshot.queryParams['WT.mc_id'];
    }
  }

  navigateToSignUp() {
    if (this.campaignId) {
      this.router.navigate(['accounts'], {queryParams: {'WT.mc_id': this.campaignId}});
    } else {
      this.router.navigate(['accounts']);
    }
  }

  agreeToTermsAndConditions() {
    this.storeAnalyticsService.trackTermsAgreement(
      this.startedReadingAt.format('MM/DD/YYYY'),
      moment.duration(moment().diff(this.startedReadingAt)).asSeconds()
    );

    this.user = this.userService.getUser();
    this.user.agreed = true;
    this.termError = false;
    this.processing = true;

    const jsonConvert: JsonConvert = new JsonConvert();
    const userRequestDto = jsonConvert.serializeObject(this.user);

    const duration = moment.duration(moment().diff(this.startedReadingAt)).asSeconds();

    this.userService.createUser(userRequestDto, this.campaignId)
      .subscribe((response: RedirectResponse) => {
          this.storeAnalyticsService.trackAccountCreated(this.user, duration);
          this.windowService.location(response.redirectUrl);
        },
        (error) => {
          this.storeAnalyticsService.trackAccountCreatedFailed(error, duration);
          this.termError = true;
          this.processing = false;
        }
      );
  }

  closeAlertBanner() {
    this.termError = false;
  }
}
